import type { TFunction } from "i18next";

// Synchronize string values with ABMonitorReportExcelGenerator.java#getFilterType
export const QUERY_TYPE = {
  PURCHASE_NO: "po",
  SALES_NO: "so",
  DESIGNATION: "designation",
  SAP_MATERIAL_NO: "sapmatno",
  CUSTOMER_MATERIAL_NO: "custalias",
  CUSTOMER_ORDER_NO: "custorder",
  INVOICE_NO: "invoiceno",
} as const;

export type QueryType = (typeof QUERY_TYPE)[keyof typeof QUERY_TYPE];

export interface SearchByData {
  type: QueryType;
  query: string;
}

export interface QueryTypeOption {
  value: QueryType;
  labelKey: string;
}

export const QUERY_TYPE_OPTIONS: QueryTypeOption[] = [
  { value: QUERY_TYPE.PURCHASE_NO, labelKey: "searchByInput.queryType.po.openorders" },
  { value: QUERY_TYPE.SALES_NO, labelKey: "searchByInput.queryType.so.openorders" },
  { value: QUERY_TYPE.DESIGNATION, labelKey: "searchByInput.queryType.part" },
  { value: QUERY_TYPE.SAP_MATERIAL_NO, labelKey: "searchByInput.queryType.sap" },
  { value: QUERY_TYPE.CUSTOMER_MATERIAL_NO, labelKey: "searchByInput.queryType.customMaterialNumber" },
  { value: QUERY_TYPE.CUSTOMER_ORDER_NO, labelKey: "searchByInput.queryType.lineCustomerOrderId" },
  { value: QUERY_TYPE.INVOICE_NO, labelKey: "searchByInput.queryType.invoiceNumber" },
];

const materialNumberRegexp = /^\d{0,15}$/;

const tooLong = (t: TFunction, fieldKey: string) =>
  t("checkoutPage.addressModal.error.isTooLongPart", { fieldname: "" + t(fieldKey) });

export const validateSearchQuery =
  (t: TFunction, labelKeys: Record<string, string>) =>
  (data: SearchByData): boolean | string => {
    switch (data.type) {
      case QUERY_TYPE.PURCHASE_NO:
        return data.query.trim().length <= 35 || tooLong(t, labelKeys[QUERY_TYPE.PURCHASE_NO]);
      case QUERY_TYPE.SALES_NO:
        return data.query.trim().length <= 10 || tooLong(t, labelKeys[QUERY_TYPE.SALES_NO]);
      case QUERY_TYPE.DESIGNATION:
        return data.query.trim().length <= 40 || tooLong(t, labelKeys[QUERY_TYPE.DESIGNATION]);
      case QUERY_TYPE.SAP_MATERIAL_NO:
        return materialNumberRegexp.test(data.query.trim()) || (t("contractOverview.materialNumberWarning") as string);
      default:
        return true;
    }
  };
